// Group GROUP 12. Existentials and Extraposition
// Complete data from "Grammar 90 Groups (GPT5) 5 Examples Each.txt"

export const group12Data = {
  "id": "group_12",
  "title": {
    "tc": "存在/虛主詞/外置",
    "sc": "存在/虚主语/外置",
    "en": "Existentials and Extraposition"
  },
  "subtitle": {
    "tc": "Existentials and Extraposition",
    "sc": "Existentials and Extraposition",
    "en": "Existentials and Extraposition"
  },
  "icon": "📝",
  "difficulty": "advanced",
  "color": "from-red-500 to-red-600",
  "topics": [
    {
      "id": "there_be",
      "title": {
        "tc": "there-be 結構",
        "sc": "there-be 结构",
        "en": "There be"
      },
      "description": {
        "tc": "學習 there-be 結構的用法",
        "sc": "学习 there-be 结构的用法",
        "en": "Learn the usage of there-be structures"
      },
      "icon": "📍",
      "difficulty": "intermediate",
      "examples": [
        {
          "id": "there_1",
          "sentence": "There is a book on the table.",
          "analysis": "There (dummy) is (V) a book (S-notional) on the table (M).",
          "translation": {
            "tc": "桌上有一本書。",
            "sc": "桌上有一本书。",
            "en": "There is a book on the table."
          }
        },
        {
          "id": "there_2",
          "sentence": "There are many options.",
          "analysis": "There (dummy) are (V) many options (S-notional).",
          "translation": {
            "tc": "有很多選擇。",
            "sc": "有很多选择。",
            "en": "There are many options."
          }
        },
        {
          "id": "there_3",
          "sentence": "There has been a mistake.",
          "analysis": "There (dummy) has been (V) a mistake (S-notional).",
          "translation": {
            "tc": "有一個錯誤。",
            "sc": "有一个错误。",
            "en": "There has been a mistake."
          }
        },
        {
          "id": "there_4",
          "sentence": "There will be a meeting tomorrow.",
          "analysis": "There (dummy) will be (V) a meeting (S-notional) tomorrow (M).",
          "translation": {
            "tc": "明天會有一個會議。",
            "sc": "明天会有一个会议。",
            "en": "There will be a meeting tomorrow."
          }
        },
        {
          "id": "there_5",
          "sentence": "There seemed to be a problem.",
          "analysis": "There (dummy) seemed (V) to be (V) a problem (S-notional).",
          "translation": {
            "tc": "似乎有一個問題。",
            "sc": "似乎有一个问题。",
            "en": "There seemed to be a problem."
          }
        }
      ],
      "teachingNotes": {
        "tc": "要點：存在引入新主題；數一致隨後項。",
        "sc": "要点：存在引入新主题；数一致随后项。",
        "en": "Key points: existential introduces new topics; number agreement follows the following item."
      }
    }
  ]
};
